export const getTheApp = {
  links: {
    iphone: 'https://apps.apple.com/app/id1487331226',
    google: 'https://play.google.com/store/apps/details?id=com.mor.tedooo',
  },
};
